import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { FinnairBoundItem } from '@fcom/dapi/api/models/finnair-bound-item';
import { FinnairTravelEndpoint } from '@fcom/dapi/api/models/finnair-travel-endpoint';
import { NotificationLayout } from '@fcom/ui-components';
import { Airport } from '@fcom/common/interfaces/booking/multi-city-state.interface';

import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'fcom-bound-selection-item',
  templateUrl: 'bound-selection-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BoundSelectionItemComponent {
  private utilsService = inject(UtilsService);

  @Input() bound: FinnairBoundItem;
  @Input() isDeparture: boolean;
  @Input() passengerCount: number;
  @Input() isSelected = false;
  @Input() disabled = false;
  @Input() tails: string[];
  @Input() notification: string;
  @Output() boundSelected: EventEmitter<FinnairBoundItem> = new EventEmitter<FinnairBoundItem>();

  readonly NotificationLayout = NotificationLayout;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  getLocation(leg: FinnairTravelEndpoint): Observable<Airport> {
    return this.utilsService.getLocation(leg.locationCode, leg.dateTime);
  }

  selectBound(bound: FinnairBoundItem): void {
    this.boundSelected.emit(bound);
  }

  onSelectionChange(): void {
    if (this.bound && !this.disabled) {
      this.selectBound(this.bound);
    }
  }
}
